import Component from '@glimmer/component';

import { Size } from 'webapp/enums/enums';

import BarLoader from 'webapp/components/bar-loader';

interface CommonFullscreenLoaderComponentInterface {
	Element: HTMLDivElement;
	Args: {
		theme?: 'grey' | 'white';
		size?: string;
	};
	Blocks: { default: [] };
}

export default class CommonFullscreenLoaderComponent extends Component<CommonFullscreenLoaderComponentInterface> {
	get size() {
		return this.args.size || Size.BIG;
	}

	get theme() {
		return this.args.theme || 'grey';
	}

	<template>
		<div class="fullscreen-loader">
			<BarLoader @size={{this.size}} @theme={{this.theme}} />
			{{yield}}
		</div>
	</template>
}
